import { Pipe, PipeTransform } from '@angular/core';

declare var _: any;

@Pipe({
    name: 'ticketMaster'
})

export class TicketMasterPipe implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            if (_.filter(array, row => row.rate == query) != '') {
                return _.filter(array, row => row.rate == query);
            } else if (_.filter(array, row => row.ticketName.toLowerCase().indexOf(query.toLowerCase()) > -1) != '') {
                return _.filter(array, row => row.ticketName.toLowerCase().indexOf(query.toLowerCase()) > -1);
            } else {
                return false;
            }
        }
        return array;
    }

}
